
namespace Matrix.Data {
    @Serenity.Decorators.filterable()
    @Serenity.Decorators.registerClass()
    export class SecurityMatchRuleGrid extends SiteEntityGrid<SecurityMatchRuleRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMatchRule'; }
        protected getDialogType() { return SecurityMatchRuleDialog; }
        protected getIdProperty() { return SecurityMatchRuleRow.idProperty; }
        protected getInsertPermission() { return SecurityMatchRuleRow.insertPermission; }
        protected getLocalTextPrefix() { return SecurityMatchRuleRow.localTextPrefix; }
        protected getService() { return SecurityMatchRuleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            $('a[href="/Data/SecurityMatchRule"]').closest('li').addClass('active');
            $('a[href="/Data/SecurityMatchRuleset"]').closest('li').removeClass('active');
        }

        protected getInitialTitle() {
            return "Security Match Rules";
        }

    }
}